import { ActionTree } from 'vuex';
import { RootState } from '~/types';

export const actions: ActionTree<RootState, RootState> = {
  async nuxtClientInit({ dispatch }, context) {
    await dispatch('events/init', context.route.params.id);
  },
};
